import UltMeta, { Meta } from "./UltMeta/index";

class State extends UltMeta {
    NOT_CONFIRMED = new Meta(1, "未确认");
    CONFIRMED = new Meta(2, "已确认");
    REJECTED = new Meta(3, "已拒绝");
}
export const STATE = new State();

// 激活状态
class ActiveState extends UltMeta {
    EXPIRE = new Meta(0, "已失效");
    ACTIVE = new Meta(1, "已激活");
}
export const ACTIVE_STATE: ActiveState = new ActiveState();

class DeleteType extends UltMeta {
    DELETE_RECORD = new Meta(1, "删除关联关系");
    DELETE_ACCOUNT = new Meta(2, "删除子账号");
}
export const DELETE_TYPE = new DeleteType();

// 申请记录- 状态
class ApplyJoinState extends UltMeta {
    NOT_CONFIRMED = new Meta(1, "待通过");
    CONFIRMED = new Meta(2, "已确认");
    REJECTED = new Meta(3, "已拒绝");
}
export const APPLY_JOIN_STATE = new ApplyJoinState();
